import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const yardattachment = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/yard/{profile}/yard-attachment',
    app: 'yard'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'yard', model: 'yardattachment' }
    ),
    { }
  )
)()

export { yardattachment, TYPES }
